import { render, staticRenderFns } from "./SupplierOrderDetail2.vue?vue&type=template&id=a2eb7c6c&scoped=true&"
import script from "./SupplierOrderDetail2.vue?vue&type=script&lang=js&"
export * from "./SupplierOrderDetail2.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOrderDetail2.vue?vue&type=style&index=0&id=a2eb7c6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2eb7c6c",
  null
  
)

export default component.exports